<div class="drawer-item-wrap">
    <div [id]="'nav-' + entity().id" class="drawer-item" [class.active]="isActive()" (click)="selectEntity()">
        <div class="drawer-item-content">
            <img src="./assets/img/websites/lpc-{{ extendedWidget()?.name }}-icon.svg" alt="lpc-widget-icon" />

            <div class="text-wrapper">
                <div class="text-item">{{ extendedWidget()?.label | translate }}</div>
                <div class="id-item" [title]="'id: ' + displayId()">id: {{ displayId() }}</div>
            </div>
        </div>
    </div>
    <div dropdown #dropdown="bs-dropdown" class="btn-group dropdown dropdown-options">
        <button
            dropdownToggle
            type="button"
            class="btn btn-action dropdown-toggle"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <span class="sp-icon icon-ellipsis"></span>
        </button>

        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="button-basic">
            <li role="menuitem" [class.disabled]="productWidgetRestricted()">
                <a class="dropdown-item" (click)="copyWidget()">
                    <span class="sp-icon icon-copy"> </span>
                    {{ "duplicate" | translate }}
                </a>
            </li>
            <li>
                <hr />
            </li>
            <li role="menuitem" [class.disabled]="productWidgetRestricted()" (click)="removeWidget()">
                <a>
                    <span class="sp-icon icon-bin color-danger"></span>
                    {{ "delete" | translate }}
                </a>
            </li>
        </ul>
    </div>
</div>
